<nav class="navbar navbar-expand-lg navbar-light header-navbar" [ngClass]="{'navbar-brand-center': menuPosition === 'Top', 'navbar-static': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Static' , 'navbar-sticky': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Fixed', 'fixed-top': isSmallScreen && menuPosition === 'Top'}">
    <div class="container-fluid navbar-wrapper">
        <div class="navbar-header d-flex">
            <div class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
                data-toggle="collapse" (click)="toggleSidebar()">
                <i class="ft-menu font-medium-3"></i>
            </div>

            <div class="navbar-brand-center">
                <div class="navbar-header">
                    <!-- <ul class="navbar-nav">
                        <li class="nav-item">
                            <div class="logo"><a class="" [routerLink]="['/dashboard']"
                                    *ngIf="config?.layout.menuPosition === 'Top'">
                                    <div class="logo-img"><img class="logo-img" alt="ContinuFlow logo"
                                            src="assets/img/logo-continuflow-new_without_name.png" style=" height:75px; width: auto;"></div><span
                                        class="text dark">ContinuFlow</span>
                                </a></div>
                        </li>
                    </ul> -->
                    <a><img src="assets/img/NewContinuflowLogo.png" style="height: 40px;width: 140px;font-size: 100px;"
                            alt="LSM logo"></a>
                </div>
                <!-- <a [routerLink]="['/dashboard']"><img class="logo-img" src="assets/img/logo-continuflow-new.png"
                        alt="ContinuFlow logo"></a> -->
            </div>
        </div>
        <div class="navbar-container">
            <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">

                <ul class="navbar-nav" (clickOutside)="toggleSearchOpenClass(false)">
                    <li class="nav-item mr-2  d-none d-lg-block">
                        {{userName}}
                    </li>
                    <li class="nav-item mr-2 d-none d-lg-block">
                        <a class="nav-link apptogglefullscreen" id="navbar-fullscreen" href="javascript:;"
                            appToggleFullscreen (click)="ToggleClass()"><i
                                class=" {{toggleClass}} font-medium-3"></i></a>
                    </li>

                    <li class="nav-item" ngbDropdown>
                        <a class="nav-link position-relative" id="dropdownBasic3" ngbDropdownToggle>
                            <i class="ft-user font-medium-3 blue-grey darken-4"></i>
                            <p class="d-none">User Settings</p>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="dropdown-menu-right">
                            <a class="dropdown-item py-1" (click)="ViewUser()">
                                <i class="ft-edit mr-2"></i>
                                <span>My Profile</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" (click)='Logout()' href="javascript:;">
                                <i class="ft-power mr-2"></i>
                                <span>Logout</span>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>





</nav>